
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class CollegeDetail extends Vue {
  collegeData: any = {};
  get params() {
    return this.$route.query;
  }
  created() {
    const data = sessionStorage.getItem('CM-CollegeList');
    if (data) {
      const temp: any = JSON.parse(data);
      this.collegeData = temp.filter((item: any, index: number) => {
        return item.id === this.params.id;
      })[0];
    }
  }
  backRoute() {
    if (window.history.length <= 1) {
      this.$router.push('CollegeList');
    } else {
      this.$router.go(-1);
    }
  }
}
